// Fire-and-forget audit breadcrumbs (navigation + session). Never blocks UX.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let lastNav = { label: null, at: 0 };

export const trackActivity = (action, label = null, description = null) => {
  try {
    const token = localStorage.getItem("jwtToken");
    if (!token) return;

    // Dedupe rapid repeat navigations to the same tab (within 3s)
    if (action === "navigate") {
      const now = Date.now();
      if (label === lastNav.label && now - lastNav.at < 3000) return;
      lastNav = { label, at: now };
    }

    const body = JSON.stringify({ action, label, description });
    const url = `${BACKEND_URL}/api/v2/activity/track`;

    // Prefer keepalive fetch so logout events still send during navigation away.
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* audit must never break the app */
  }
};
